<ng-template #favHeaderTemplate>
</ng-template>
<ng-template #favTemplateContent>
  @if (profile | async; as p) {
    <div class="p-3 d-flex flex-row flex-wrap gap justify-content-center justify-content-md-start"
      >
      @for (f of p.favorites; track f) {
        <a class="p-1 fav-block" [href]="f.url" target="_blank" [title]="f.url">
          <span>
            <img height="35" width="35" [ngSrc]="'https://icons.duckduckgo.com/ip3/' + getDomainFromUrl(f.url) + '.ico'"
              alt="icône favori">
          </span>
          <span class="text-center">{{ f.name }}</span>
          <button role="button" title="Supprimer le favori" aria-label="Supprimer le favori" class="remove-icon"
            (click)="removeFavorite(f, $event)">
            <fa-icon icon="trash-alt"></fa-icon>
          </button>
        </a>
      }
      <button type="button" aria-label="Ajouter un favori" class="fav-block"
        (click)="addingFavorite = true">
        <fa-icon class="color-grey" icon="plus-circle" size="2x"></fa-icon>
        <span class="text-center">Ajouter</span>
      </button>
    </div>
  } @else {
    <ls-spinner/>
  }
</ng-template>
<app-dash-block title="Mes favoris" [headerTemplate]="favHeaderTemplate"
  [contentTemplate]="profile ? favTemplateContent : null">
</app-dash-block>

<app-dynamic-modal-form
  size="md"
  [object]="addingFavorite"
  [generator]="userFavoriteFormGeneratorService"
  [actions]="[{label: 'Ajouter', class: 'btn-primary', icon: 'plus-circle', submit: true}]"
  (onSubmit)="onSubmit($event)"
  (onCancel)="addingFavorite = undefined"
  title="Ajouter un favori">
</app-dynamic-modal-form>

